import TypeRepository from "@/repositories/dexpara/Type/TypeRepository";
import makeStore from "@/storages/Base/Storage";
import value from "@/storages/type/Value";

const store = makeStore('type', TypeRepository);

export default {
    ...store,
    modules: {
        value,
    }
};